import { IDateRangeValue, ISelectedOperatorInfo, IHierarchyValue } from "../types/faceted-filter.types";
import { FilterUtils } from "./filter.utils";

export class DisplayValue {
    public static FromPath(path: string): string {
        return path.replace(/\|/g, ' > ');
    }

    public static FromStringArray(values: string[], path: string): string {
        const valueDisplay: string = values.length > 1 ? `${values[0]} + ${values.length - 1} more`
                                                       : values[0];
                                                       
        return `${this.formatPathDisplay(path)}: ${valueDisplay}`;
    }

    public static FromBooleanStringArray(values: string[], path): string {
        return `${this.formatPathDisplay(path, true)}: ${values[0]}`;
    }

    public static FromDateRange(value: IDateRangeValue, path: string, showDateRange: boolean = true): string {
        if (!showDateRange) {
            return FilterUtils.pathToDisplayPathsList(path).join(': ');
        }

        const valueDisplay = `${value.startDate} - ${value.endDate}`;
        
        return `${this.formatPathDisplay(path, true)}: ${valueDisplay}`;
    }

    public static FromOperatorValue(value: ISelectedOperatorInfo, path: string): string {
        const valueDisplay = `${value.operatorInfo.label} ${value.operand}`;
        
        return `${this.formatPathDisplay(path)} ${valueDisplay}`;
    }

    public static FromHierarchies(values: IHierarchyValue[], path: string, valuesAreFacets: boolean): string {
		// Based on feedback, we want to preserve the first path (Dealers). TODO: need to verify
        const pathRoot = path.split('|')[0] + ' > ';
        let valueDisplay: string;
        if (!valuesAreFacets) {
            valueDisplay = values.map(v => v.value).join(', ');
        } else {
            valueDisplay = values.length > 1 ? `${values[0].value} + ${values.length - 1} more`
                                             : values[0].value;
        }
        const omitLastNode = valuesAreFacets && values.length === 1;
        const displayPaths: string = this.formatPathDisplay(path, omitLastNode);
        // return `${pathRoot}${displayPaths}${displayPaths.length ? ':' : ''} ${valueDisplay}`;
        return valueDisplay;
    }

    private static formatPathDisplay(path: string, omitLastNode: boolean = false): string {
        const pathsList = FilterUtils.pathToDisplayPathsList(path);
        
        if (omitLastNode)
            pathsList.pop();
        
        return pathsList.join(' > ');
    }
}